
export interface CheckItem {
  label: string;
  status: 'pass' | 'fail';
  description: string;
}

export interface AnalysisResult {
  score: number;
  checks: CheckItem[];
  optimizedPrompt: string;
  explanation: string;
}

export enum LoadingState {
  IDLE = 'IDLE',
  ANALYZING = 'ANALYZING',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR'
}

export interface UserProfile {
  id: string;
  name: string;
  email: string;
  photoURL?: string;
}

export interface HistoryItem {
  id: string;
  timestamp: number;
  originalPrompt: string;
  analysisResult: AnalysisResult;
}

export interface Country {
  code: string;
  name: string;
  flag: string;
  adjective: string; // e.g. "Argentino", "Chileno"
}

export const SUPPORTED_COUNTRIES: Country[] = [
  { code: 'AR', name: 'Argentina', flag: '🇦🇷', adjective: 'Argentino' },
  { code: 'CL', name: 'Chile', flag: '🇨🇱', adjective: 'Chileno' },
  { code: 'UY', name: 'Uruguay', flag: '🇺🇾', adjective: 'Uruguayo' },
  { code: 'PY', name: 'Paraguay', flag: '🇵🇾', adjective: 'Paraguayo' },
  { code: 'PE', name: 'Perú', flag: '🇵🇪', adjective: 'Peruano' },
  { code: 'CO', name: 'Colombia', flag: '🇨🇴', adjective: 'Colombiano' },
  { code: 'GT', name: 'Guatemala', flag: '🇬🇹', adjective: 'Guatemalteco' },
];

// Admin types
// Admin email is loaded from environment variable for security
// Falls back to default if not set (the actual security is enforced via Firebase Security Rules)
export const ADMIN_EMAIL = process.env.ADMIN_EMAIL || 'david@inteligencialegal.com.ar';

export interface UserStats {
  userId: string;
  email: string;
  name: string;
  analysisCount: number;
  lastActive: number;
}

export interface DailyStats {
  date: string;
  analysisCount: number;
}

export interface AdminAnalytics {
  totalUsers: number;
  totalAnalyses: number;
  analysesToday: number;
  analysesThisWeek: number;
  analysesThisMonth: number;
  topUsers: UserStats[];
  dailyStats: DailyStats[];
}

// Modal Configuration Types
export interface AdvertisingModalConfig {
  enabled: boolean;
  title: string;
  message: string;
  linkText?: string;
  linkUrl?: string;
  frequency: 'always' | 'once_per_session' | 'once_per_day' | 'once_per_week' | 'every_2_analyses' | 'every_3_analyses' | 'every_5_analyses';
  buttonText: string;
  timeoutSeconds: number; // Timeout in seconds before modal can be closed (default: 5)
}

export type PracticeArea =
  | 'Civil/Comercial'
  | 'Penal'
  | 'Laboral'
  | 'Administrativo'
  | 'Familia'
  | 'Previsional'
  | 'Otro';

export interface UserDetails {
  firstName: string;
  lastName: string;
  organization: string;
  city: string;
  whatsapp: string;
  practiceAreas: PracticeArea[];
  profileCompletedAt?: unknown;
  profileUpdatedAt?: unknown;
}

export type UserDetailsInput = Omit<UserDetails, 'profileCompletedAt' | 'profileUpdatedAt'>;
